import { HasuraClaimKey } from 'constants/auth';
import { getDashboardSubscriptionName } from 'constants/payments';
import type { Viewer } from 'constants/user';
import { fromPostgresArray } from 'utils/shared/hasura';

/**
 * A paid Dashboard plan on the account: the only thing member offers can upgrade. The free launch
 * window grants Dashboard access but has no plan behind it, so it does not count here.
 */
export const hasDashboardSubscription = (viewer: Viewer) => {
  const claim = viewer?.viewer ? viewer.claims?.[HasuraClaimKey.Subscriptions] : undefined;
  return !!claim && fromPostgresArray(claim).includes(getDashboardSubscriptionName());
};
